module.exports = __webpack_public_path__ + "img/web-dark.14785ea3.svg";